<div class="dashboard h-100">
    <div class="dashboard-card no-padding d-flex flex-column justify-content-between"
        style="max-width: 800px">
        <div class="row">
            <div class="col-12">
                <div class=" d-flex flex-column padding-container">
                    <h2 class="card-dash-title">Controle de
                        permissões</h2>
                </div>
            </div>

            <div class="col-12 dashboard-card-body">
                <ng-container *ngIf="loading">
                    <table #table>
                        <tbody>
                            <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '200px',
                                    marginBottom:'0'                            
                                      }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td class="item-number">
                                    <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '40px',
                                    marginBottom:'0',
                                    marginLeft: 'auto'
                                  }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td>
                                    <div
                                        style="display: flex; gap: 16px; justify-content: flex-end;">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '16px',
                                            marginBottom:'0',
                                            borderRadius: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <table *ngIf="!loading && data.length > 0">
                    <thead>
                        <tr>
                            <th>Grupo</th>
                            <th style="text-align:right;">Permissões associadas
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let permission of data">
                            <td class="doc-item"
                                [style.max-width.px]="tableSize"
                                style="width: 100%;">
                                {{permission.group}}</td>
                            <td style="text-align:right;">
                                {{permission.permissions}}
                            </td>
                            <td>
                                <div class="table-options">
                                    <app-tooltip text="Visualizar"
                                        [position]="'top'">
                                        <button
                                            (click)="redirectToDetails(permission.id)">
                                            <svg-icon
                                                src="assets/images/icon-eye.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                    <!-- <app-spacer [right]="19"></app-spacer>
                                    <button
                                        (click)="editPermission(permission.id)"
                                        *ngIf="permissionObj.canChange">
                                        <svg-icon src="assets/images/icon-edit.svg"></svg-icon>
                                    </button> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12">
                <div class="padding-container d-flex flex-row justify-content-between"
                    *ngIf="loading || data.length > 0">
                    <app-button [inverted]="true"
                        (onClick)="redirect('/app/permissions/list')">
                        Ver todos
                    </app-button>

                    <app-button (click)="addPermission()" class="add-button"
                        [disabled]="loading" *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            fill="var(--white)" class="mr-2"></svg-icon>
                        Adicionar permissão
                    </app-button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 " *ngIf="data.length === 0 && !loading">
                <ng-container *ngIf="!permissionObj.canAdd">
                    <app-empty-content [isVisible]="true"
                        title="Defina as permissões"
                        description="Ainda não existem permissiões cadastradas"
                        icon="/assets/images/figure_3d_search.png">
                    </app-empty-content>
                </ng-container>

                <ng-container *ngIf="permissionObj.canAdd">
                    <app-empty-content [isVisible]="true"
                        title="Defina as permissões"
                        description="Ainda não existem permissiões cadastradas"
                        (onClick)="addPermission()" [haveButtonIcon]="true"
                        buttonLabel="Adicionar permissão"
                        icon="/assets/images/figure_3d_search.png">
                    </app-empty-content>
                </ng-container>
            </div>
        </div>
    </div>
</div>